import { gql } from '@apollo/client';

export const getAssets = (depId: any, src: any) => {
  if (depId !== undefined && depId !== null) {
    return gql`
    {
      scanned_count: assets_count(needScan: false, departmentId: ${depId}, source: "${src}")
      total_count: assets_count(departmentId: ${depId}, source: "${src}")
    }
  `;
  } else {
    return gql`
      {
        scanned_count: assets_count(needScan: false, source: "${src}")
        total_count: assets_count(source: "${src}")
      }
    `;
  }
};

export const cancelRequestMutation = gql`
  mutation cancelRequest($requestId: Float!) {
    cancelRequest(requestId: $requestId) {
      requestNumber
    }
  }
`;

export const readMainDepartments = gql`
  {
    departments: readDepartments {
      id
      Name
      Abbreviation
    }
  }
`;

export const GET_DEPARTMENTS = gql`
  {
    departments: readDepartments {
      id
      Name
      Abbreviation
    }
  }
`;

export const getDepartment = (departmentId: any) => {
  return gql`
  {
    department: readOneDepartment(id: ${departmentId}){
      id
      Name
      Abbreviation
    }
  }
`;
};

export const getOwnersByDept = (depId: any) => {
  return gql`
  {
  physicalOwnerView: readPhysicalOwnerViewByDepartmentId(departmentId: ${depId}){
    DepartmentId
    DepartmentName
    PhysicalOwner
    PropertyCoordinator
    ItemsVerified
    TotalItems
    PercentComplete
    Source
    DepartmentName
    mailStop
    }
  }
`;
};

export const GET_CHART_DATA = gql`
  query getChartData($assetFilter: AssetsInput) {
    chartData: getChartData(assetFilter: $assetFilter) {
      id
      name
      abbreviation
      needScan
      scanned
      total
      percentDone
    }
  }
`;

export const getMissingItemsByOwner = gql`
  query assetsByOwner($status: String!, $owner: String!) {
    assetsByOwner(status: $status, owner: $owner) {
      source
      BarCode
      Description
    }
  }
`;

export const getItemsByOwner = gql`
  query assetsByOwner($status: String, $owner: String!) {
    assetsByOwner(status: $status, owner: $owner) {
      Status
      BarCode
      Description
      Description2
      Description3
      SerialNumber
      AssetNumber
      Owner
      OriginalPurchaser
      Location
      Acquired
      EquipmentClass
      AllComments
      VerifyDate
      UserId
      VerifyType
      Year
      Department
      CapitalSubDeptFund
      source
      needScan
      AssetID
      VerifyId
      DepartmentID
    }
  }
`;

//! FIX SALVAGE COUNT

// export const request_count = gql`
//   query request_count {
//     salvageCount
//   }
// `;

export const salvageCount = gql`
  query salvageCount {
    salvageCount
  }
`;

export const transferCount = gql`
  query transferCount($status: String!) {
    transferCount(status: $status)
  }
`;

export const requestedItemCountWithStatus = (status: string) => {
  return gql`
    { 
    requestedItems_count(status: "${status}")
    }
    `;
};

export const requestedItemCountWithStatusAndNegation = (status: string, negate: boolean) => {
  return gql`
    {
        requestedItems_count(status: "${status}", negate: ${negate})
    }
    `;
};

export const requestedItemCount = gql`
  {
    requestedItems_count
  }
`;

export const requestsCount = (status: string, negate: boolean) => {
  return gql`
    {
      requests_count(status: "${status}", negate: ${negate})
    }
  `;
};

export const eoneErrors = (errors: boolean) => {
  return gql`
    {
        eone_count(errors:${errors})
    }
    `;
};

export const addWidgetBarCounts = (deptId: number, deptAbbr: string /* , status: string, negate: boolean */) => {
  return gql`
    {
      requests_count(dept: ${deptId}, status: "Requested", negate: false)
      orders_count: requests_count(dept: ${deptId}, status: "Ordered", negate: false)
      barcoded_count: requestedItems_count(status: "Barcoded", dept: \"${deptAbbr}\")
      nonBarcoded_count:requestedItemsView_count(dept:\"${deptAbbr}\", needsBarcode: false)
      eoneReady_count: requestedItems_count(status: "Ready for EOne", dept: \"${deptAbbr}\")
      success_count: eone_count(updateType: "A", updateStatus: "Import Successful", dept: ${deptId})
      errors_count: eone_count(updateType: "A", errors: true, dept: ${deptId})
    }
  `;
};
export const transferWidgetBarCounts = (dept: number) => {
  return gql`
  {
    transferInitiated_count: eone_count(updateType: "C", updateStatus: "Transfer Initiated", dept:${dept})
    transferRecieved_count: eone_count(updateType: "C", updateStatus: "Transfer Received", dept:${dept})
    transferPendingApproval_count: eone_count(updateType: "C", updateStatus: "Transfer Installed, Pending Approval", dept:${dept})
    transferReadyForEOne_count: eone_count(updateType: "C", updateStatus: "Ready for EOne", dept:${dept})
    transferSuccess_count: eone_count(updateType: "C", updateStatus: "Import Successful", dept:${dept})
    transferErrors_count: eone_count(updateType: "C", errors: true, dept:${dept})
  }
  `;
};
